// Monta o payload de execução de fiscalização enviado à API, removendo as referências de
// input de arquivo (capturarFotoRef) que não podem ser serializadas (ex: JSON.stringify do axios
// lança "Converting circular structure to JSON" quando há uma foto anexada).
// Usado tanto no preview quanto no envio final, para que ambos vejam exatamente o mesmo payload.
export function montarPayloadFiscalizacao(execucaoFiscalizacao) {
  return {
    ...execucaoFiscalizacao,
    formulario: (execucaoFiscalizacao.formulario || [])
      .filter((value) => !!value.valor)
      .map(({ capturarFotoRef, ...resto }) => resto),
  };
}
